import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

type ReadyState =
  | 'loading'
  | 'success'
  | 'error'
  | 'site-selection'
  | 'plugin_activation';

type InitialState = {
  ready: ReadyState;
};

const initialState: InitialState = {
  ready: 'loading',
};

const bootstrapSlice = createSlice({
  initialState,
  name: 'bootstrap',
  reducers: {
    ready: (state, action: PayloadAction<ReadyState>) => {
      state.ready = action.payload;
    },
  },
});

export const { ready } = bootstrapSlice.actions;
export const bootstrapAction = createAction('bootstrap');
export const isReady = (state: RootState) => state.bootstrap.ready;
export default bootstrapSlice.reducer;
